module.exports = __webpack_public_path__ + "img/furnitureshop-faq.8179ef0e.png";